function updateUserSession(postData, id = null) {
    let contentId = id;
    if(contentId === null) {
        contentId = document.head.querySelector('meta[name="craft-element-id"').content ?? null
    }
    if(contentId) {
        postData['elementId'] = contentId
    }

    return fetch('/actions/contentful-module/default/update-session', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(postData)
        })
        .then(response => response.json())
        .then(data => {
            return data
        })
}

window.updateUserSession = updateUserSession;

let documentHubspotScript = null;
class HubspotForms {
    constructor(container) {

        this._container = container;
        this._formid = container.dataset.formid;
        this._type = container.dataset.type;
        this._trigger = container.dataset.trigger;
        this._userData = null;
        this._form;
        this._formContainer = container.dataset.formcontainer;
        this._elementId = container.dataset.id;
        this._reload = true;
        this._siteFooter = false;
        if(container.dataset.reload === 'false') {
            this._reload = false;
        }
        this._newsletter = false;
        if(container.dataset.newsletter === 'true') {
            this._newsletter = true;
        }
        if (container.dataset.siteFooter === 'true') {
            this._siteFooter = true;
        }

        if(!this._formid) {
            console.warn('no form id set');
            return;
        }

        if (typeof userJson !== 'undefined') {
            this._userData = userJson;
        }

        this.appendScript();
    }

    appendScript() {
        if(!documentHubspotScript) {
            let ele = document.createElement('script');
            ele.setAttribute("type", "text/javascript");
            ele.setAttribute("src", '//js.hsforms.net/forms/embed/v2.js');
            ele.async = false;
            document.getElementsByTagName('head')[0].append(ele);
            documentHubspotScript = ele;
        }
        documentHubspotScript.addEventListener('load', (event) => {
            this.init();
        });
    }

    init() {
        this.loadForm().then(response => {
            if(this._type == 'modal') {
                this.initModal();
            }
            if(this._type == 'inline') {
                this.initInline();
            }
        });
    }

    loadForm() {
        let that = this;

        window.addEventListener('message', (event) => {
            // Remove any existing errors
            that._container.querySelectorAll('.fieldError').forEach((el) => {
                el.remove();
            })

            /**
             * These are shown in the documentation here: https://developers.hubspot.com/beta-docs/reference/cms/forms#form-events
             * but don't actually exist on the event.data object
             * event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmitted' &&
             */
            // console.log(event);
            if (event.data.formGuid === that._formid) {
                if(event.data.accepted) {
                    updateUserSession(event.data, that._elementId).then(result => {
                        if(that._reload) {
                            location.reload()
                        }
                        if(that._newsletter) {
                            // that._container.querySelector('.action').remove();
                            that._container.querySelector('.msg').style.display = 'block';
                        }
                        if (that._siteFooter) {
                            that._container.querySelector(that._formContainer).classList.add("hidden");
                            that._container.querySelector(that._formContainer).nextElementSibling.classList.add("shown");
                        }
                    });
                } else {
                    event.data.validationResults.forEach((error) => {
                        var fieldError = document.createElement('span');
                        fieldError.classList.add('fieldError');
                        fieldError.innerText = error.localizedVisitorErrorMessage;
                        that._container.querySelector('input[name="' + error.fieldName + '"]').parentElement.append(fieldError);
                    });
                }
            }
        });

        return new Promise((resolve, reject) => {
            hbspt.forms.create({
                portalId: '47343286',
                formId: this._formid,
                onFormReady: (form) => {
                    that._form = form;
                    if(that._userData) {
                        if(that._form.querySelector("input[name='firstname']")) {
                            that._form.querySelector("input[name='firstname']").value = that._userData['FirstName'];
                        }
                        if(that._form.querySelector("input[name='lastname']")) {
                            that._form.querySelector("input[name='lastname']").value = that._userData['LastName'];
                        }
                        if(that._form.querySelector("input[name='email']")) {
                            that._form.querySelector("input[name='email']").value = that._userData['Email'];
                        }
                        if(that._form.querySelector("input[name='zip']")) {
                            that._form.querySelector("input[name='zip']").value = that._userData['PostalCode'];
                        }
                    }
                    resolve(true);
                },
                onFormSubmitted: (form, data) => {
                    console.log(form, data);
                },
            });
        });
    }

    initModal() {
        if(!this._trigger) {
            console.warn('no trigger set');
            return;
        }

        let trigger = this._container.querySelector(this._trigger);
        if(!trigger) {
            console.warn('trigger not found');
            return;
        }

        trigger.addEventListener('click', (event) => {
            event.preventDefault();

            let modalClose = document.createElement("a");
            modalClose.setAttribute("href", "#");
            modalClose.classList.add("modalClose");
            modalClose.innerText = 'X';
            modalClose.addEventListener('click', (event) => {
                this.closeModal();
            });

            document.getElementById("loading-overlay").append(this._form);
            document.getElementById("loading-overlay").querySelector("form").append(modalClose);
            document.body.classList.toggle("is-loading");
        });

    }

    closeModal() {
        document.querySelector("#loading-overlay form").remove();
        document.body.classList.toggle("is-loading");
    }

    initInline() {
        // let form = document.createElement('form');
        // form.id = `hsForm_${this._formid}`;

        let formContainer = this._container.querySelector(this._formContainer);

        if(!formContainer) {
            console.warn('no place to put the form');
        }

        formContainer.append(this._form);
    }
}

Array.from(document.querySelectorAll('[data-gated]')).forEach(el => new HubspotForms(el));